import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {DropdownItemIcon} from './dropdownItemIcon';

/*
 * Style.
 */

const StyledVisibilityDescriptionDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.normal};
`;

/*
 * Props.
 */

interface CompanyDropdownItemProps extends DropdownItemProps {
  shouldRenderVisibilityDescription?: boolean;
}

/*
 * Component.
 */

export const CompanyDropdownItem: FC<CompanyDropdownItemProps> = (props) => {
  const theme = useUserTheme();
  const {isChecked, onSelect, shouldRenderVisibilityDescription} = props;
  return (
    <DropdownItem isChecked={isChecked} onSelect={onSelect}>
      <DropdownItemIcon
        label={null}
        iconName="buildingFilledSmall"
        color={theme.greys.shade70}
        iconSize={16}
      />
      <DropdownItemContent isChecked={isChecked}>
        <Trans id="company-dropdown-item-company-label">Company</Trans>
        {shouldRenderVisibilityDescription && (
          <StyledVisibilityDescriptionDiv>
            <Trans id="company-dropdown-item-visibility-description">Everyone can view</Trans>
          </StyledVisibilityDescriptionDiv>
        )}
      </DropdownItemContent>
    </DropdownItem>
  );
};
